import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler } from 'chart.js';
import { useTranslation } from '../../i18n';
import API_BASE_URL from '../../config/api';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler);

const SwimmingHeartRateHistogram = ({ fileId }) => {
  const { t } = useTranslation();
  const [laps, setLaps] = useState([]);

  useEffect(() => {
    if (!fileId) return;
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/fit/parsed-data/${fileId}`);
        if (Array.isArray(response.data.laps)) setLaps(response.data.laps);
      } catch (error) {
        console.error('Error al obtener datos del archivo FIT:', error);
      }
    };
    fetchData();
  }, [fileId]);

  if (!laps.length) return null;

  const chartData = {
    labels: laps.map((_, i) => `Lap ${i + 1}`),
    datasets: [
      {
        label: t('elevationProfile.hrLapSeriesLabel'),
        data: laps.map(l => l.avg_heart_rate || 0),
        borderColor: 'rgba(255,165,0,1)',
        backgroundColor: 'rgba(255,165,0,0.15)',
        borderWidth: 2,
        tension: 0.3,
        pointRadius: 3,
        pointBackgroundColor: 'rgba(255,165,0,1)',
        fill: true,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: { display: false },
      tooltip: { callbacks: { label: (c) => ` FC: ${c.raw} bpm` } },
    },
    scales: {
      x: { ticks: { font: { size: 8 }, maxTicksLimit: 12 } },
      y: { ticks: { font: { size: 9 } }, title: { display: true, text: t('elevationProfile.axisBpm'), font: { size: 9 } } },
    },
  };

  return <Line data={chartData} options={chartOptions} height={110} />;
};

export default SwimmingHeartRateHistogram;
